import {Button, Select} from "antd";
import {CloseCircleOutlined} from '@ant-design/icons';

import styles from "./page-filers.module.scss";
import SelectField from "../../shared/components/SelectField";
import {countryOptions, cityOptions} from "./settings";

const PageFilters = ({selectCountry, selectCity, countries, cities, children}) => {
    return (
        <div className={styles.wrapper}>
            <div>
                {/*<Button onClick={resetFilters} className={`${styles.btn} ${styles.resetBtn}`} icon={<CloseCircleOutlined/>}>*/}
                {/*    Filters*/}
                {/*</Button>*/}
                {/*<Button onClick={resetSorters} className={`${styles.btn} ${styles.resetBtn}`} icon={<CloseCircleOutlined/>}>*/}
                {/*    Sorters*/}
                {/*</Button>*/}
            </div>
            <div className={styles.box}>
                <div className={styles.select}>
                    <SelectField handleChange={selectCountry} placeholder="Select country" options={countries} />
                </div>
                <div className={styles.select}>
                    <SelectField handleChange={selectCity} placeholder="Select city" options={cities} />
                </div>
                {children}
            </div>
        </div>
    )
}

export default PageFilters;
